import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/checkout-style/overview"
      }}>{`CheckoutStyle`}</a>{` object that defines the CSS styles to apply to the input element.`}</p>
    <p>{`For more details and examples you can refer to the guide on `}<a parentName="p" {...{
        "href": "/docs/payments/universal-checkout/drop-in/customize-checkout/web#styling-inputs"
      }}>{`Styling Inputs`}</a>{` for Drop-in, `}<inlineCode parentName="p">{`HeadlessHostedInput`}</inlineCode>{` accepts the same configuration.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      